import React from 'react';
import NoMatch404 from '../no-match-404/NoMatch404';

import './BankAccountOnboarding.scss';

const BankAccountOnboarding = () => {
  const token = new URLSearchParams(window.location.search).get('token');

  let dippsUrl = `https://qa.my.manymore.com/en/token-handler/enrolment-wizard?stage-2-token=${token}`;
  if (window.location.origin.endsWith('porterbuddy.com')) {
    dippsUrl = `https://my.manymore.com/en/token-handler/enrolment-wizard?stage-2-token=${token}`;
  }

  if (token === null) return <NoMatch404 />;
  return (
    <iframe
      className={'dippsIframe'}
      title={'Manymore bank account form'}
      src={dippsUrl}
    />
  );
};

export default BankAccountOnboarding;
